import { styled } from "../../theme";

export const HeaderContainer = styled.header<{ hidden?: boolean }>`
  width: 100%;
  height: ${({ hidden }) => (hidden ? "0vh" : "calc(100vh * 0.17);")};
  overflow: ${({ hidden }) => (hidden ? "hidden" : "initial")};
  box-sizing: border-box;
  height: ${({ hidden }) => (hidden ? "0vh" : "calc(100vh * 0.17);")};
  display: flex;
  flex-wrap: no-wrap;
  justify-content: center;
  z-index: 5;
  position: relative;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    height: calc(100vh * 0.17);
    padding-right: 0;
    padding-left: 0;
  }
`;

export const HeaderWrapper = styled.div<{ hidden?: boolean }>`
  width: calc(100vw * 0.82);
  height: ${({ hidden }) => (hidden ? "0vh" : "calc(100vh * 0.17);")};
  overflow: ${({ hidden }) => (hidden ? "hidden" : "initial")};
  box-sizing: border-box;
  max-height: ${({ hidden }) => (hidden ? "0vh" : "calc(100vh * 0.17);")};
  display: flex;
  flex-wrap: no-wrap;
  justify-content: space-between;
  z-index: 5;

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 100%;
    padding-right: 0;
    padding-left: 0;
    width: 100%;
  }
`;

export const HeaderLanguageSelectorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 2%;
  height: 100%;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    max-width: 30%;
    display: none;
  }
  &.mobile {
    display: none;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
      display: flex;
      position: relative;
      flex-direction: row-reverse;
      width: 100%;
      justify-content: flex-start;
      align-self: flex-end;
      height: inherit;
      .language-selector-flag-container {
        width: 1.5em;
        height: 1.5em;
      }
    }
  }
`;

export const HeaderRightContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: flex-end;
  width: 65%;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    flex-direction: column;
  }
`;
export const HeaderLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: flex-start;
  width: 35%;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    img {
      padding-top: 1em;
      width:90%;
    }
  }
`;

export const HeaderLogoContainerStyle = styled.a`
  display: block;
  box-sizing: border-box;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    img {
      max-width: 100%;
    }
  }
  img {
    max-height: 100%;
  }
`;

export const HeaderTitleContainerStyle = styled.div<{ autoWidth: number }>`
  width: ${({ autoWidth }) => (autoWidth === 0 ? "600px" : `${autoWidth}px`)};
  box-sizing: border-box;
  padding: 1em;
  color: ${({ theme }) => theme.color.primary};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 100%;
    padding: 0em;
    font-size: 1.2em;
  }
`;
